import { defineComponent, Types } from 'vibegame';

export const StepController = defineComponent({
  step: Types.i32,
  target: Types.i32,
  max: Types.i32,
});
